/**
 * Filter for Profile Name it the name is too long
 */
const filter = () => {
    return (input) => {
        let output = angular.isDefined(input) ? input : "";
        if (output.length > 45) {
            return output.substring(0, 45) + "...";
        }
        else {
            return output;
        }
    };
};
const ɵ0 = filter;
export const CompanyNameFilter = {
    name: 'companyNameFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-company-name.filter.js.map